import React from "react";
import { setAdditionalClasses } from "../assets/js/utils";

function InteractiveIcon({ icon, onPress, active }) {
  return (
    <div
      className={`interactive-icon${setAdditionalClasses(
        ["interactive-icon--active", "not-active"],
        [active, !active]
      )}`}
      onClick={onPress}
    >
      <img src={icon} alt="" className="icon" />
    </div>
  );
}

export default InteractiveIcon;
